module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8t2pl"))).then(() => parcelRequire('hEqeo'));